import { useTranslation } from "react-i18next";

import FilterGroup from "@/features/certifications/community-flags/components/FilterGroup";
import {
  TYPE_FILTERS,
  VERDICT_FILTERS,
} from "@/features/certifications/community-flags/constants";
import { FlagFiltersProps } from "@/features/certifications/community-flags/types";

import "../styles.css";

const FlagFilters = ({
  type,
  verdict,
  notCountedCount,
  onTypeChange,
  onVerdictChange,
  onShowNotCounted,
}: FlagFiltersProps) => {
  const { t } = useTranslation();

  return (
    <div className="flag-filters flex flex-wrap items-center justify-between gap-300">
      <div className="flex flex-wrap items-center gap-500">
        <FilterGroup
          label={t("certification.admin.communityFlags.type")}
          options={TYPE_FILTERS}
          value={type}
          getLabel={(option) =>
            t(`certification.admin.communityFlags.types.${option}`)
          }
          onChange={onTypeChange}
        />

        <FilterGroup
          label={t("certification.admin.communityFlags.verdict")}
          options={VERDICT_FILTERS}
          value={verdict}
          getLabel={(option) =>
            t(`certification.admin.communityFlags.verdicts.${option}`)
          }
          onChange={onVerdictChange}
        />
      </div>

      <button
        type="button"
        className="flag-not-counted-link flex items-center gap-100 body-s-medium"
        onClick={onShowNotCounted}
      >
        {t("certification.admin.communityFlags.notCounted.link")}

        <span className="flag-count-pill body-xs-regular">
          {notCountedCount}
        </span>
      </button>
    </div>
  );
};

export default FlagFilters;
